import { render, staticRenderFns } from "./orderItemList.vue?vue&type=template&id=201ed802&scoped=true"
import script from "./orderItemList.vue?vue&type=script&lang=js"
export * from "./orderItemList.vue?vue&type=script&lang=js"
import style0 from "./orderItemList.vue?vue&type=style&index=0&id=201ed802&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201ed802",
  null
  
)

export default component.exports